import gtag_event from './gtag-init';
import {otp_init} from '../../global/otp';
import {whatsapp_validation_form, check_telesales_valid, get_enquiry_count, increment_enquiry_count, should_require_otp, clean_phone_number} from '../../global/validation-form';
import {insert_leads_to_db} from '../../global/leads-submission';

jQuery(function ($) {
    // eslint-disable-next-line no-undef
    let is_disable_leads_submission_form = global_params['disable_leads_submission_form'];
    // eslint-disable-next-line no-undef
    let custom_copy_leads = global_params['custom_copy_leads'];
    var current_wa_button_clicked_position = null;
    const GENERAL_WA_MODAL_ID = '#whatsapp-form-modal';
    const UNIT_TYPE_WA_MODAL_ID = '#unit-type-modal';
    const CONTACT_WA_CLASS = 'section.contact';
    const WA_FORM_CLASS = 'form.whatsapp-form';
    const BANNER_SECTION_CLASS = 'section.section-banner-v2';
    const COVER_IMAGE_ELM = $(GENERAL_WA_MODAL_ID + ' .modal-content img:first');
    const MICROSITE_SUPERLEADS_ID = $('#nndc-footer__superleads-id').val();

    // init global vars
    var microsite_whatsapp_modal = null;
    var current_form_class = null;
    var name_field = null;
    var number_field = null;
    var message_field = null;
    var alert_field = null;
    var process_submit = false;
    var custom_pretext_wa = null;
    var cover_image_src = null;
    var cover_image_srcset = null;
    var cover_image_sizes = null;
    var cluster_v2_unit_name = null;
    var contact_position = null;
    let is_telesales_valid = null;

    function change_wa_form_vars(_microsite_whatsapp_modal) {
      microsite_whatsapp_modal = _microsite_whatsapp_modal;
      current_form_class = microsite_whatsapp_modal + ' ' + WA_FORM_CLASS;
      name_field = $(current_form_class + ' [name="name"]');
      number_field = $(current_form_class + ' [name="whatsapp_number"]');
      message_field = $(current_form_class + ' [name="message"]');
      alert_field = $(current_form_class + ' .message-failed');
      setTimeout(() => {
        disable_leads_submission_form(); //check on change
      }, 60);
    }
    change_wa_form_vars(GENERAL_WA_MODAL_ID);

    function change_wa_form(selector) {
      let _big_title = 'Hubungi Kami';
      let _title = 'Silakan isi nomor Whatsapp Anda untuk memulai percakapan dengan sales konsultan kami.';
      let _btn_submit = 'Chat Sekarang';
      let _is_download_brochure = 0;
      let _download_brochure_url = '';
      let _lead_type_id = 1;
      let _lead_type_name = 'Whatsapp';
      custom_pretext_wa = selector.attr('data-pretext');

      if ( selector.hasClass('btn-download-brochure') ) {
          _big_title = 'Download Brochure';
          _title = 'Silakan isi form di bawah ini terlebih dahulu untuk download brosur.';
          _btn_submit = 'Download';
          _is_download_brochure = 1;
          _download_brochure_url = selector.attr('href');
          _lead_type_id = 3;
          _lead_type_name = 'Brochure';
      }

      if ( custom_copy_leads['is_custom_copy_leads'] == true && !selector.hasClass('btn-download-brochure')) {
        _big_title = custom_copy_leads['title'];
        _title = custom_copy_leads['subtitle'];
      }

      if (selector.hasClass('btn-cta-general')) {
        _big_title = selector.data('form-title');
        _title = selector.data('form-description');
        _btn_submit = selector.data('form-submit-text');
        _is_download_brochure = 1;
        _download_brochure_url = selector.attr('href');
        _lead_type_id = 3;
        _lead_type_name = 'Brochure';

        change_form_cover(selector.data('form-cover'));
      }

      // clear form
      name_field.val('');
      number_field.val('');
      $(current_form_class + ' select').prop('selectedIndex', 0);

      $(microsite_whatsapp_modal + ' .modal-title-lg').text( _big_title );
      $(current_form_class + ' .modal-title').text( _title );
      $(current_form_class + ' [type="submit"]').text( _btn_submit );
      $(current_form_class + ' [name="is_download_brochure"]').val( _is_download_brochure );
      $(current_form_class + ' [name="download_brochure_url"]').val( _download_brochure_url );
      $(current_form_class + ' [name="lead_type_id"]').val( _lead_type_id );
      $(current_form_class + ' [name="lead_type_name"]').val( _lead_type_name );
      $(current_form_class + ' [type="submit"]').prop( 'disabled', false );
    }

    function change_form_cover(url_img) {
      if (url_img == '') {
        return false;
      }

      cover_image_src = COVER_IMAGE_ELM.attr('src');
      cover_image_srcset = COVER_IMAGE_ELM.attr('srcset');
      cover_image_sizes = COVER_IMAGE_ELM.attr('sizes');

      COVER_IMAGE_ELM.attr('src', url_img);
      COVER_IMAGE_ELM.attr('srcset', '');
      COVER_IMAGE_ELM.attr('sizes', '');
    }

    $(GENERAL_WA_MODAL_ID).on('hidden.bs.modal', function () {
      if (cover_image_src != null) {
        COVER_IMAGE_ELM.attr('src', cover_image_src);
      }

      if (cover_image_srcset != null) {
        COVER_IMAGE_ELM.attr('srcset', cover_image_srcset);
      }

      if (cover_image_sizes != null) {
        COVER_IMAGE_ELM.attr('sizes', cover_image_sizes);
      }
    })

    function submit_whatsapp_form(data) {
      if (data == -1 || data == '') {
        alert_field.text('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.').show();
        return;
      }

      // submit success
      if(data.success) {
        $(current_form_class + ' [name=submit_status]').val('1').trigger('change');

        // send GA tracking
        gtag_event('Whatsapp Submission', (contact_position != null ? contact_position : current_wa_button_clicked_position ));

        if ( $(current_form_class + ' [name="is_download_brochure"]').val() == 1 ) {
          do_download_brochure();
        } else {
          redirect_submit_whatsapp_form();
        }
      } else {
        $(current_form_class + ' .message-success').hide();
        $(current_form_class + ' .message-failed').html('<p>' + data.data.message + '</p>').show();
      }
    }

    function redirect_submit_whatsapp_form() {

      $(current_form_class + ' .modal-body label').hide();
      $(current_form_class + ' .modal-body input').hide();
      $(current_form_class + ' .modal-body button').hide();
      $(current_form_class + ' .message-success').show();

      var project_name = $(current_form_class + ' [name=project_name]').val();
      var telesales_number = $(current_form_class + ' [name=telesales_number]').val
      ();
      var sender_name = $(current_form_class + ' [name=name]').val();
      var unit_name = cluster_v2_unit_name;


      // var msg = message_field.val() != undefined ? message_field.val() : 'Saya%20ingin%20bertanya%20mengenai%20info%20';

      var msg = msg_pretext(project_name, sender_name, unit_name);

      setTimeout(function() {
        location.href = whatsapp_base_url()+'/send?text='+msg+''+'&phone=' + telesales_number;
      }, 1000); // 1 second
    }
    function msg_pretext(project,sender,unit) {
      let msg = 'Saya%20ingin%20bertanya%20mengenai%20info%20'+encodeURIComponent(project);
      let msg_from_banner_pretext = message_field.val();
      let msg_from_custom_pretext_cta = custom_pretext_wa;
      const superleadsText = ` (ID: ${MICROSITE_SUPERLEADS_ID})`;

      if(msg_from_banner_pretext != undefined && msg_from_banner_pretext != '') {
        msg = encodeURIComponent(msg_from_banner_pretext);
      }

      if(msg_from_custom_pretext_cta != undefined && msg_from_custom_pretext_cta != '') {

        let replace_project_name = {
          'text': msg_from_custom_pretext_cta,
          'target': '[project_name]',
          'replace': project,
        };

        let replace_unit_name = {
          'text': replace_all_text(replace_project_name),
          'target': '[unit_name]',
          'replace': unit,
        };

        let replace_sender_name = {
          'text': replace_all_text(replace_unit_name),
          'target': '[sender_name]',
          'replace': sender,
        };

        msg = encodeURIComponent(replace_all_text(replace_sender_name));
      }
      if( !is_mobile() ){
        msg = decodeURIComponent(msg) + superleadsText;
      } else {
        msg = msg + encodeURIComponent(superleadsText);
      }

      return msg;
    }

    function whatsapp_base_url() {
      if( is_mobile() ) {
        return 'https://api.whatsapp.com';
      }

      return 'https://api.whatsapp.com';
    }

    function replace_all_text(data) {
      let text = data.text;
      let target = data.target;
      let replace_with = data.replace;
      let result = text.replaceAll(target, replace_with);
      return result;
    }

    function do_download_brochure() {
      $(microsite_whatsapp_modal).modal('hide');

      let _url = $(current_form_class + ' [name="download_brochure_url"]').val();
      let _url_decode = atob( _url );
      _url_decode = decode_shortcode_url(_url_decode);

      window.open( _url_decode, '_blank' ).focus();
      window.location.reload();
    }

    function decode_shortcode_url(url) {
      let project_name = $(current_form_class + ' [name=project_name]').val();
      let telesales_number = $(current_form_class + ' [name=telesales_number]').val();
      let sender_name = $(current_form_class + ' [name=name]').val();

      let replace_words = {
        '[project_name]' : encodeURIComponent(project_name),
        '[telesales_number]' : telesales_number,
        '[sender_name]' : sender_name,
      };

      for (const shortcode in replace_words) {
        if (replace_words.hasOwnProperty(shortcode)) {
          url = replace_all_text({
            'text': url,
            'target': shortcode,
            'replace': replace_words[shortcode],
          });
        }
      }
      
      return url;
    }

    function whatsapp_submit_form_ajax(e, frm, nonce_request) {
      e.preventDefault();
      var btn_submit = current_form_class + ' [type="submit"]';


      let leads_name = name_field.val();
      let leads_number = number_field.val();
      let leads_form = {
        'name': leads_name,
        'number': leads_number,
        'number_field': number_field,
        'alert_field': alert_field,
      };

      //set session storage for store temp data
      sessionStorage.setItem('temp_leads_contact_data', JSON.stringify(
        {
          'name': leads_name,
          'number': leads_number,
        }
      ));

      if (whatsapp_validation_form(leads_form) == false) {
        gtag_event('Leads form button clicked', current_wa_button_clicked_position+'-not-validated');
        
        return false;
      }

      const recommendations_ready = window.wait_for_recommendation_r123_listings
        ? window.wait_for_recommendation_r123_listings()
        : Promise.resolve();

      return recommendations_ready.then(function () {
        const microsite_project_status = $('#nndc-footer__project-status').val() || '';
        const has_recommendation_location = ['city', 'province'].some(function(field) {
          const value = $('#nndc-footer__' + field).val();
          return value && value !== '-';
        });
        // eslint-disable-next-line no-undef
        if(microsite_project_status.toLowerCase() == 'evergreen' && global_params.pre_enquiry_settings && global_params.pre_enquiry_settings.enable && MICROSITE_SUPERLEADS_ID && has_recommendation_location && window.has_recommendation_r123_listings && window.has_recommendation_r123_listings()) {
          // eslint-disable-next-line no-undef
          return do_recommendation_r123_modal();
        }

        // Track enquiry count and conditionally require OTP every 3rd enquiry
        const cleanedNumber = clean_phone_number(leads_number);
        const nextEnquiryCount = get_enquiry_count(cleanedNumber) + 1;

        // Only call OTP on 1st, 3rd, 6th, 9th... enquiries
        if (should_require_otp(nextEnquiryCount)) {
          console.info('Enquiry count for ' + cleanedNumber + ': ' + nextEnquiryCount + '. OTP validation required.');
          if (otp_init(current_form_class, e, leads_number, btn_submit) === false) {
            return false;
          }
        }

        if (true === process_submit) {
          alert('Mohon ditunggu, data anda sedang diproses');
          return;
        }

        // Increment enquiry count after submission
        const newCount = increment_enquiry_count(cleanedNumber);

        // Clear otp_validated cookie if next enquiry will require OTP validation
        const nextEnquiry = newCount + 1;
        if (should_require_otp(nextEnquiry)) {
          document.cookie = 'otp_validated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }

        gtag_event('Leads form button clicked', current_wa_button_clicked_position+'-validated');

        process_submit = true;
        $(btn_submit).prop('disabled', true);
        // eslint-disable-next-line no-undef
        const refresh_request = nonce_request || $.post(global_params.ajax_url, { action: 'refresh_whatsapp_nonce' });
        refresh_request.done(function(response) {
          if (!response || !response.success || !response.data || !response.data.nonce) {
            frm.find('.message-failed').text('Mohon maaf ada kesalahan. Silakan coba lagi.').show();
            $(btn_submit).prop('disabled', false);
            process_submit = false;
            return;
          }
          frm.find('[name="_wpnonce"]').val(response.data.nonce);
          let data_form = frm.serialize() + '&current_url=' + encodeURIComponent(window.location.href);

          // insert leads data to DB
          insert_leads_to_db(frm);

          $.ajax({
            type: frm.attr('method'),
            url: frm.attr('action'),
            data: data_form,
            beforeSend: function() {
              $(current_form_class + ' .message-text').hide();
              $(current_form_class + ' .loader').show();
              $(btn_submit).prop('disabled', true);
              process_submit = true;
            },
            success: function (data) {
              $(current_form_class + ' .loader').hide();
              submit_whatsapp_form(data);
              $(btn_submit).prop('disabled', false);
              process_submit = false;
            },
            // eslint-disable-next-line no-unused-vars
            error: function(xhr, status, error) {
              frm.find('.loader').hide();
              frm.find('.message-failed').text('Mohon maaf ada kesalahan. Silakan coba lagi.').show();
              $(btn_submit).prop('disabled', false);
              process_submit = false;
            },
          });
        }).fail(function() {
          frm.find('.message-failed').text('Mohon maaf ada kesalahan. Silakan coba lagi.').show();
          $(btn_submit).prop('disabled', false);
          process_submit = false;
        });
      });
    }

    function whatsapp_init(selector) {
      // change form vars
      change_wa_form_vars(GENERAL_WA_MODAL_ID);

      current_wa_button_clicked_position = selector.data('position');
      gtag_event('Whatsapp Button Clicked', current_wa_button_clicked_position);
      change_wa_form( selector );

      if(is_telesales_valid == null) { // check telesales number validity to avoid cache issue
        is_telesales_valid = check_telesales_valid();
      }
    }

    function bypass_leads_submission_form(selector) {
      let btn_download_brochure = '.btn-download-brochure';
      let first_project_name = $('[name=project_name]').first().val();
      let first_telesales_number = $('[name=telesales_number]').first().val();

      $(selector).not(btn_download_brochure).each(function () {
        let btn = $(this);
        let pretext = this.getAttribute('data-pretext') || btn.data('pretext');
        let text = pretext && pretext != ''
          ? pretext
          : 'Saya ingin bertanya mengenai info [project_name]';

        text = replace_all_text({ text, target: '[project_name]', replace: first_project_name });
        text = replace_all_text({ text, target: '[unit_name]', replace: '' });
        text = replace_all_text({ text, target: '[sender_name]', replace: '' });

        let whatsapp_url = whatsapp_base_url() + '/send?text=' + encodeURIComponent(text) + '&phone=' + first_telesales_number;

        btn.attr('data-toggle', '');
        btn.attr('data-target', '');
        btn.attr('href', whatsapp_url);
      });
    }

    function disable_leads_submission_form() {
      if ( is_disable_leads_submission_form == 1 ) {
        let btn_whatsapp_fab = 'button.btn-whatsapp-general[data-position=fab]';

        bypass_leads_submission_form('.btn-whatsapp-general');
        $(btn_whatsapp_fab).removeAttr('type');
        $(btn_whatsapp_fab + '[data-position=fab]').addClass('pt-2');
        changeElement($(btn_whatsapp_fab),'a');
      }
    }
    disable_leads_submission_form();


    function changeElement(element, newElement) {
      element.wrap('<' + newElement + '>');
      newElement = element.parent();
      //Copying Attributes
      $.each(element.prop('attributes'), function () {
        newElement.attr(this.name, this.value);
      });
      element.contents().unwrap();
      return newElement;
    }

    function is_mobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        return true;
      }else{
        return false;
      }
    }

    // <!------------- Whatsapp button
    // whatsapp button do not remove
    // $('.btn-whatsapp-general').on('click', function () {
    //   whatsapp_init($(this));
    // });

    $('.unit-detail-link').on('click', function() {
    cluster_v2_unit_name = $(this).data('unit-name');
      // change form vars
      change_wa_form_vars(UNIT_TYPE_WA_MODAL_ID);
    });

    let wa_contact_form_class = CONTACT_WA_CLASS + ' ' + WA_FORM_CLASS;
    $(wa_contact_form_class + ' [name="name"]').attr('placeholder', 'Tulis nama lengkap');
    $(wa_contact_form_class + ' [name="whatsapp_number"]').attr('placceholder', 'Tulis nomor Whatsapp');
    $(wa_contact_form_class + ' [type="submit"]').text('Whatsapp');
    // end of Whatsapp button -------------!>

    // <!------------- Whatsapp form submit
    $(GENERAL_WA_MODAL_ID + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      change_wa_form_vars(GENERAL_WA_MODAL_ID);
      contact_position = null;
      whatsapp_submit_form_ajax(e, $(this));
    });

    $(UNIT_TYPE_WA_MODAL_ID + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      change_wa_form_vars(UNIT_TYPE_WA_MODAL_ID);
      contact_position = null;
      whatsapp_submit_form_ajax(e, $(this));
    });

    $(CONTACT_WA_CLASS + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      e.preventDefault();
      let frm = $(this);
      // change form vars
      change_wa_form_vars(CONTACT_WA_CLASS);
      contact_position = 'contact-section';
      console.info('contact_position', contact_position);

      // Refresh the nonce before submitting and reuse this request in the shared handler.
      // eslint-disable-next-line no-undef
      const nonce_request = $.post(global_params.ajax_url, { action: 'refresh_whatsapp_nonce' }, function(response) {
        if (response && response.success && response.data && response.data.nonce) {
          $('input[name="_wpnonce"]').val(response.data.nonce);
          console.info('refresh_whatsapp_nonce success', response.data.nonce);
        }
      });

      whatsapp_submit_form_ajax(e, frm, nonce_request);
    });

    $(BANNER_SECTION_CLASS + ' ' + WA_FORM_CLASS).on('submit', function (e) {
      // change form vars
      change_wa_form_vars(BANNER_SECTION_CLASS);

      whatsapp_submit_form_ajax(e, $(this));
    });
    // end of Whatsapp form submit -------------!>

    // <!------------- Whatsapp button
    $(document).on('click', '.btn-whatsapp-general:not(.btn-chat-box)', function(){
      let $this = $(this);

      // eslint-disable-next-line no-undef
      let gl_params = global_params;

      if (
        typeof gl_params['overwrite_whatsapp'] !== undefined &&
        gl_params['overwrite_whatsapp'] !== null &&
        typeof gl_params['overwrite_whatsapp']['enable'] !== undefined &&
        true === gl_params['overwrite_whatsapp']['enable']
      ) {
        location.href = gl_params['overwrite_whatsapp']['link'];
        return false;
      }

      // Refresh the nonce before initializing
      $.post(gl_params.ajax_url, { action: 'refresh_whatsapp_nonce' }, function(response) {
        if (response.success) {
          $('input[name="_wpnonce"]').val(response.data.nonce);
          console.info('refresh_whatsapp_nonce success', response.data.nonce);
        }
      });
      
      whatsapp_init($this);
      $('.bannerv2-slider').slick('slickPause');
    });
});



// WEBPACK FOOTER //
// ./scripts/page-template/template-aimm/whatsapp-submission.js